import wixLocation from 'wix-location';
export function dropdown1_change(event) {
		wixLocation.to(`/unipage/${$w("#dropdown1").value.replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-")}`);
 
}	

//$w("#dropdown1").onChange((event) => {
//    wixLocation.to(`/unipage/${$w("#dropdown1").value.replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-")}`);
//});


//export function dropdown1_change(event) {
//	wixLocation.to(`/unipage/${$w("#dropdown1").value.replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-").replace(" ","-")}`);
//}

/**
*	Adds an event handler that runs when an input element's value
 is changed.
	[Read more](https://www.wix.com/corvid/reference/$w.ValueMixin.html#onChange)
*	 @param {Event} event
*/
